import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import PasswordGate from "@/components/PasswordGate";
import Overview from "@/pages/Overview";
import Content from "@/pages/Content";
import Audience from "@/pages/Audience";
import Comments from "@/pages/Comments";
import Hashtags from "@/pages/Hashtags";
import Strategy from "@/pages/Strategy";
import Settings from "@/pages/Settings";
import Competitors from "@/pages/Competitors";
import History from "@/pages/History";
import Calendar from "@/pages/Calendar";
import Ideas from "@/pages/Ideas";

function App() {
  return (
    <PasswordGate><BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/contenuti" element={<Content />} />
          <Route path="/pubblico" element={<Audience />} />
          <Route path="/commenti" element={<Comments />} />
          <Route path="/hashtag" element={<Hashtags />} />
          <Route path="/concorrenti" element={<Competitors />} />
          <Route path="/storico" element={<History />} />
          <Route path="/strategia" element={<Strategy />} />
          <Route path="/calendario" element={<Calendar />} />
          <Route path="/idee" element={<Ideas />} />
          <Route path="/impostazioni" element={<Settings />} />
        </Route>
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter></PasswordGate>
  );
}

export default App;
